



















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Bar } from 'vue-chartjs/legacy';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { registerables } from 'chart.js';

ChartJS.register(ChartDataLabels, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

interface ProductData {
  name: string;
  value: number;
  data: number[];
}

@Component({
  components: { Bar },
})
export default class StackedColumnChart extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, required: true }) subtitle!: string;
  @Prop({ type: Number, default: 250 }) height!: number;
  @Prop({ type: Array, required: true })
  stackedColumnChartData!: ProductData[];

  @Prop({ type: Array, required: true })
  restProducts!: Array<{ name: string; value: number }>;

  colors: string[] = ['#28C76F', '#FF9F43', '#3A7BC7', '#71C7FF', '#A196FF', '#7f71fc', '#FF4560'];

  get chartData() {
    return {
      labels: [''],
      datasets: this.stackedColumnChartData.map((product, index) => ({
        label: product.name,
        data: product.data,
        backgroundColor: this.colors[index] || '#000',
      })),
    };
  }

  get chartOptions() {
    return {
      indexAxis: 'y' as const,
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        tooltip: {
          callbacks: {
            label: (context: any) => {
              const value = context.raw;
              const total = context.chart.data.datasets.reduce(
                (acc: number, ds: any) => acc + ds.data[0],
                0,
              );
              const percentage = Math.round((value / total) * 100);
              if (context.dataset.label === 'Rest') {
                const lines: string[] = [];
                lines.push(`Rest: ${value.toLocaleString('de-DE')} (${percentage}%)`);
                const validProducts = this.restProducts.filter((product: any) => product.value > 0);
                validProducts.forEach((product: any) => {
                  const prodPercentage = Math.round((product.value / total) * 100);
                  lines.push(
                    `${product.name}: ${product.value.toLocaleString(
                      'de-DE',
                    )} (${prodPercentage}%)`,
                  );
                });
                return lines;
              }
              return [
                `${context.dataset.label}: ${value.toLocaleString('de-DE')} (${percentage}%)`,
              ];
            },
          },
          backgroundColor: 'rgba(0,0,0,0.9)',
          boxPadding: 5,
          padding: 8,
        },
        datalabels: {
          formatter: (value: number, context: any) => {
            const total = context.chart.data.datasets.reduce(
              (acc: number, ds: any) => acc + ds.data[0],
              0,
            );
            const percentage = Math.round((value / total) * 100);
            return `${percentage}%`;
          },
          color: '#fff',
        },
        legend: {
          labels: {
            boxWidth: 15,
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          ticks: {
            // callback: (value: any) => value.toLocaleString('de-DE'),
            display: false,
          },
          grid: {
            display: false,
          },
        },
        y: {
          stacked: true,
          grid: {
            display: false,
          },
        },
      },
    };
  }
}
